import {ZITI_DATA_SERVICE, ZitiDataService, ExtensionService, GrowlerService} from "ziti-console-lib";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  Inject,
} from '@angular/core';
import {isEmpty, cloneDeep, unset} from 'lodash';
import _ from 'lodash';
import {ActivatedRoute, Router, NavigationEnd} from "@angular/router";
import {Location} from "@angular/common";
import { Namespace } from '@netfoundry-ui/shared/model';
import { ApiService, LoggerService, NamespaceService, AgentService } from "@netfoundry-ui/shared/services";

import { Subscription, Subject } from "rxjs";
import { GrowlerData } from "@netfoundry-ui/shared/growler";

@Component({
    selector: 'app-namespace-form',
    templateUrl: './namespace-form.component.html',
    styleUrls: ['./namespace-form.component.scss'],
    standalone: false
})
export class NamespaceFormComponent implements OnInit, OnChanges {
  @Input() isModal = false;
  @Input() formData: any = {};
  close: EventEmitter<any> = new EventEmitter<any>();

  isEditing = false;

  formView = 'simple';

  errMap:  any = {};
  timeout = Date.now() + 10 * 60 * 1000; 

  saveSubject = new Subject<boolean>;
  mappingConfigUpdateSubject = new Subject<boolean>;

  moreActions: any[] = [];
  protected isLoading = false;
  initData: any = {};
  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
  _dataChange = false;
  public errors: any = {};
  basePath = '';
  private dnsTimer: any;
  private isDestroyed = false;
  previousRoute;
  errorState = false;
  hasDNSError = false;
  hasStatusError = false;
  protected usePreviousLocation = true;
  subscription: Subscription = new Subscription();
  @Input() entityId: string;
  baseHref: any;
  formInit = false;
  frontdoorId: string;
  waitingOnDnsInfo = false;
  cNames;
  transformedStatus;
  aRecord;
  
  processing = false;
  domainNameInvalid = false;
  domainNameErrorMessage = '';
  constructor(
      private apiService: ApiService,
      public agentService: AgentService,
      private logger: LoggerService,
      public svc: NamespaceService,
      private growlerService: GrowlerService,
      @Inject(ZITI_DATA_SERVICE) protected zitiService: ZitiDataService,
      private location: Location,
      protected router?: Router,
      protected route?: ActivatedRoute,
  ) {
    this.previousRoute = router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
        this.subscription.add(
            this.route?.params?.subscribe(params => {
                const id = params['id'];
                if (isEmpty(id)) {
                    this.entityId = 'create';
                } else {
                  this.entityId = id;
                }
            })
        );
        this.subscription.add(
            router?.events.subscribe((event: any) => {
                  if (!event?.snapshot?.routeConfig?.path) {
                      return;
                  }
                  const pathSegments = event.snapshot.routeConfig.path.split('/');
                  this.basePath = pathSegments[0];
                
            })
        );
        this.initBaseHref();
  }

  ngOnInit(): void {
      this.subscription.add(
          this.apiService.currentTenant.subscribe((tenant) => {
              this.agentService.getAccountById(tenant.id).subscribe((frontdoor: any) => {
                  this.frontdoorId = frontdoor.id;
                  if (this.entityId === 'create') {
                      this.formData = new Namespace();
                      this.initData = cloneDeep(this.formData);
                      this.entityUpdated();
                      return;
                  } else {
                      this.isEditing = true;
                      this.isLoading = true;
                      this.getNamespace();
                  }
              })
          })
      );
    this.formInit = true;
  }

  
  getNamespace() {
    return this.svc.getSingleNamespace(this.frontdoorId, this.entityId).subscribe({
      next: (entity: Namespace) => {
        this.formData = entity;
        this.initData = cloneDeep(this.formData);
        this.entityUpdated();
        if(this.formData.status === 'PENDING_DNS_VERIFICATION') {
          this.getDNSInformation(this.formData.id);
          this.transformedStatus = 'Pending DNS Verification'

        } else if (this.formData.status === 'NEW') {
          this.transformedStatus = 'New'
          this.waitingOnDNS(this.formData.id);

        } else if(this.formData.status ==='ERROR') {
          this.transformedStatus = 'Error'
          this.hasStatusError = true;
        }
        this.isLoading = false;
      },
      error: (err) => {
        this.growlerService.show(
        new GrowlerData(
            'error',
            'Error',
            'Error retrieving namespace data.',
        )
    );
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isEditing = !isEmpty(this.formData.id);
  }

  initBaseHref() {
        try {
            const base = document?.querySelector('base');
            this.baseHref = base ? base.getAttribute('href') : '/';
        } catch (error) {
            this.baseHref = '/';
        }
    }

  entityUpdated() {
    if (this.formData.id) {

    }
    
    unset(this.formData, '_links');
    this.initData = cloneDeep(this.formData);
  }

  headerActionRequested(action: any) {
    switch(action.name) {
      case 'save':
        this.save();
        break;
      case 'close':
        this.closeForm();
        break;
      case 'toggle-view':
        this.formView = action.data;
        break;
    }
  }


save(event?: any) {
  this.processing = true;
  this.isLoading = true;
  
  const proms = [];

  // 1. Handle Subject logic for Editing mode
  if (this.isEditing) {
    this.saveSubject.next(true);
    const updateSubjectPromise = new Promise<boolean>((resolve) => {
      // Note: Consider taking(1) so this doesn't hang
      this.mappingConfigUpdateSubject.asObservable().subscribe((wasUpdated: boolean) => {
        resolve(wasUpdated);
      });
    });
    proms.push(updateSubjectPromise);
  } else {
    // If not editing, we push 'true' so the Promise.all logic stays consistent
    proms.push(Promise.resolve(true));
  }

  // 2. Branch between Create and Update
  // We wrap the observable in toPromise() or use a new Promise wrapper 
  // so Promise.all can actually track it.
  const httpCall = this.isEditing 
    ? this.svc.update(this.formData, this.frontdoorId, this.formData.id)
    : this.svc.create(this.formData, this.frontdoorId);

  const requestPromise = new Promise((resolve, reject) => {
    httpCall.subscribe({
      next: (result: any) => {
        if (this.isModal) {
          this.closeModal(true, true);
        } else {
          this.initData = this.formData;
          this.formData = result;
      if(result?.status === 'NEW') {
        this.waitingOnDnsInfo = true;
        this.waitingOnDNS(result.id);
      }
          this.isLoading = false;
          this._dataChange = false;
        }
        resolve(true);
      },
      error: (err) => {
        this.processErrors(err);
        this.isLoading = false;
      }
    });
  });

  proms.push(requestPromise);

  // 3. Finalize
  Promise.all(proms)
    .then((results) => {
      // results[0] is the Subject, results[1] is the HTTP call
      if (results[0] === true && results[1] === true) {
        // TODO: Success message
      }
    })
    .catch(err => {
      // Handle errors here
    })
    .finally(() => {
      this.processing = false;
      this.isLoading = false;
    });
}

      copyText(text: string) {
  navigator.clipboard.writeText(text).then(() => {
        this.growlerService.show(
        new GrowlerData(
            'success',
            'Success',
            'Copied to clipboard',
             text + ' has been copied to your clipboard'
        )
        );
    });
    }

  waitingOnDNS(namespaceId) {
    if (this.isDestroyed) return;
    const currentTime = Date.now();
    this.svc.getSingleNamespace(this.frontdoorId, namespaceId).subscribe((data: any) => {
      if ((data.status === 'NEW')&& currentTime < this.timeout ) {
        this.waitingOnDnsInfo = true;
        this.transformedStatus = 'New'
         this.dnsTimer =  setTimeout(() => {
            this.waitingOnDNS(namespaceId)
          }, 5000)
      }
      else if(data.status === 'ERROR') {
        this.errorState = true;
        this.transformedStatus = 'Error'
      }
      else if(data.status === 'PENDING_DNS_VERIFICATION') {
        this.transformedStatus = 'Pending DNS Verification'
        this.getDNSInformation(data.id)

    }
  })
  }

      ngOnDestroy() {
        this.isDestroyed = true; 
        
        if (this.dnsTimer) {
            clearTimeout(this.dnsTimer); // Kill any pending timer
        }
        this.subscription.unsubscribe();
    }

  getDNSInformation(id){
        this.svc.getDNSRecords(this.frontdoorId, id).subscribe((data: any) => {
          if(data) {
            this.waitingOnDnsInfo = false;
            this.cNames = data.cnameRecords;
            this.aRecord = data.aRecord;
          }
        },
        (error) => {
          this.hasDNSError = true;
            this.growlerService.show(
                new GrowlerData(
                  'error',
                  'Error',
                  'Unable to retrieve DNS information',
                  'Unable to retrieve DNS information for this namespace.'
                )
              );
        }
      )
      
  }

  
  clear(): void {
  }

  closeModal(refresh = true, ignoreChanges = false, data?: any, event?: any): void {
    this.close.emit({refresh: refresh});
    if (event) {
        event.stopPropagation();
    }
  }

  closeForm(refresh = true, ignoreChanges = false, data?, event?) {
      if (!ignoreChanges && this._dataChange) {
          const confirmed = confirm('You have unsaved changes. Do you want to leave this page and discard your changes or stay on this page?');
          if (!confirmed) {
              return;
          }
      }
      if (this.isModal) {
          this.closeModal(refresh, ignoreChanges);
      } else {
          this.returnToListPage();
      }
  }

  returnToListPage() {
    if (this.location && this.previousRoute && this.usePreviousLocation) {
      this.location.back();
    } else {
      // Namespaces is a tab on the HTTP shares page, not a page of its own.
      this.router?.navigateByUrl(`${this.basePath}/http-shares?tab=namespaces`);
    }
  }


  private processErrors(errors: any) {
    const apiErrors: string[] = errors?.error?.errors || [];
    const nameRequiredError = apiErrors.find((error) => error.includes('$.name'));
    if (nameRequiredError) {
      this.domainNameInvalid = true;
      this.domainNameErrorMessage = nameRequiredError.split(':').slice(1).join(':').trim();
      this.growlerService.show(
        new GrowlerData(
          'error',
          'Namespace create request failed',
          this.domainNameErrorMessage,
        )
      );
      return;
    }

    this.growlerService.show(
      new GrowlerData(
        'error',
        'Namespace create request failed',
        errors?.error?.detail || 'Namespace create request has failed.',
      )
    );
  }

  validateDomainName() {
    this.domainNameInvalid = isEmpty(this.formData.name);
    if (this.domainNameInvalid) {
      this.domainNameErrorMessage = 'Must not be blank';
    } else {
      this.domainNameErrorMessage = '';
    }
  }

  mappingConfigUpdateHandler(wasUpdated: boolean) {
    this.mappingConfigUpdateSubject.next(wasUpdated);
  }

  


  /**
   * True when this form is showing an existing namespace. Derived from the route/input
   * rather than isEditing, which is only set once the account lookup resolves, so the
   * header title doesn't briefly read "Create New ..." on an edit.
   */
  get isExistingEntity(): boolean {
    return !isEmpty(this.formData?.id) || (!isEmpty(this.entityId) && this.entityId !== 'create');
  }

}